import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { components } from '@atlaskit/select';
var AsyncTooltip = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlaskit/tooltip" */'@atlaskit/tooltip').then(function (module) {
    return {
      default: module.default
    };
  });
});
export var ClearIndicator = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ClearIndicator, _React$PureComponent);
  var _super = _createSuper(ClearIndicator);
  function ClearIndicator() {
    var _this;
    _classCallCheck(this, ClearIndicator);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (event) {
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }
      // Prevent focus when clear on blurred state
      var _this$props = _this.props,
        clearValue = _this$props.clearValue,
        selectProps = _this$props.selectProps;
      clearValue();
      //@ts-ignore react-select unsupported props
      if (selectProps && !selectProps.isFocused) {
        event.stopPropagation();
      }
    });
    return _this;
  }
  _createClass(ClearIndicator, [{
    key: "render",
    value: function render() {
      var clearValueLabel = this.props.selectProps.clearValueLabel;
      var Indicator = /*#__PURE__*/React.createElement(components.ClearIndicator, _extends({}, this.props, {
        innerProps: _objectSpread(_objectSpread({}, this.props.innerProps), {}, {
          onMouseDown: this.handleMouseDown
        })
      }));
      return clearValueLabel ? /*#__PURE__*/React.createElement(React.Suspense, {
        fallback: Indicator
      }, /*#__PURE__*/React.createElement(AsyncTooltip, {
        content: clearValueLabel
      }, Indicator)) : Indicator;
    }
  }]);
  return ClearIndicator;
}(React.PureComponent);